import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Header/Header.css';
import './LandingHeader.css';

/**
 * LandingHeader component for the landing page
 * Simplified version of Header without authentication requirements
 */
const LandingHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="header landing-header">
      <div className="container header-container">
        <div className="logo">
          <Link to="/">
            <h1><i className="bi bi-music-note-beamed"></i> Unissn</h1>
          </Link>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          <span className="menu-icon"></span>
        </button>

        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link to="/login" className="nav-link">Login</Link>
            </li>
            <li className="nav-item">
              <Link to="/register" className="nav-link">Register</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default LandingHeader;
